import { useEffect, useState } from 'react'

import { AlertStatus } from './AlertStatus.type'

export const ALERT_STATUS_RETENTION_PERIOD_DAYS = 60
export const ALERT_STORAGE_KEY = 'alert-messages'

export const useDismissedAlert = (
  messageId: string,
  showCloseButton: boolean
) => {
  const [isDismissed, setIsDismissed] = useState(false)
  const [showNotification, setShowNotification] = useState(true)

  useEffect(() => {
    if (!showCloseButton) {
      return
    }

    const now = new Date()
    const storageRecord = localStorage.getItem(ALERT_STORAGE_KEY)
    if (storageRecord === null) {
      return
    }

    const dismissedMessages = JSON.parse(storageRecord)

    dismissedMessages.forEach(
      (message: { id: string; date: string; notification: string }) => {
        if (message.id === messageId) {
          const storedDate = new Date(message.date)
          const differenceInMs = now.valueOf() - storedDate.valueOf()
          const differenceInDays = differenceInMs / (1000 * 60 * 60 * 24)
          if (differenceInDays <= ALERT_STATUS_RETENTION_PERIOD_DAYS) {
            setIsDismissed(true)
            message.notification = AlertStatus.NOTIFICATION_HIDE
            setShowNotification(false)
          } else {
            message.notification = AlertStatus.NOTIFICATION_SHOW
          }
        }
      }
    )

    // Update localStorage with modified messages
    localStorage.setItem(ALERT_STORAGE_KEY, JSON.stringify(dismissedMessages))
  }, [messageId, showCloseButton])

  return { isDismissed, setIsDismissed, showNotification, setShowNotification }
}
